// File: app.routing.ts
// Author: Joseph M Diaz
// Date: 4/24/2017
// Desc: Root routing for the app.
// Other Contributors:

import { NgModule } from '@angular/core';
import { panelbarRouting, } from './app-routing.module';
import { AuthGuard } from './auth.guard';

@NgModule({
    imports: [panelbarRouting],
    providers: [AuthGuard]
})
export class AppRoutingModule { }
